var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bv-top'),_vm._v(" "),_c('van-panel',{attrs:{"title":_vm.item.title,"desc":_vm.item.summary}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.item.content)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }